// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".message-actions-buttons{display:-ms-flexbox;display:flex;-ms-flex-pack:end;justify-content:flex-end}.message-actions-buttons .button-drop{-ms-flex:0 0 auto;flex:0 0 auto}.message-actions-buttons .button-drop:not(:last-child){margin-right:14px}\n", ""]);
// Exports
module.exports = exports;
